import React, { useEffect } from 'react'

type Props = {
  title: string
  description: string
  image?: string
  url?: string
}

export default function Seo({ title, description, image, url }: Props) {
  useEffect(() => {
    if (typeof document === 'undefined') return

    document.title = title

    const setMeta = (attr: { name?: string; property?: string }, content: string) => {
      if (!content) return
      const selector = attr.name ? `meta[name="${attr.name}"]` : `meta[property="${attr.property}"]`
      let el = document.head.querySelector(selector) as HTMLMetaElement | null
      if (!el) {
        el = document.createElement('meta')
        if (attr.name) el.setAttribute('name', attr.name)
        if (attr.property) el.setAttribute('property', attr.property)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    setMeta({ name: 'description' }, description)
    setMeta({ property: 'og:title' }, title)
    setMeta({ property: 'og:description' }, description)
    if (image) setMeta({ property: 'og:image' }, image)
    if (url) setMeta({ property: 'og:url' }, url)
    setMeta({ name: 'twitter:card' }, image ? 'summary_large_image' : 'summary')
    setMeta({ name: 'twitter:title' }, title)
    setMeta({ name: 'twitter:description' }, description)
    if (image) setMeta({ name: 'twitter:image' }, image)
  }, [title, description, image, url])

  return null
}

